export default "__VITE_ASSET__D1C68Z2C__"